import { render, staticRenderFns } from "./AttendanceChatInput.vue?vue&type=template&id=b58d4f3a&scoped=true"
import script from "./AttendanceChatInput.vue?vue&type=script&lang=js"
export * from "./AttendanceChatInput.vue?vue&type=script&lang=js"
import style0 from "./AttendanceChatInput.vue?vue&type=style&index=0&id=b58d4f3a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58d4f3a",
  null
  
)

export default component.exports
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtnDropdown});
